import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { TbArrowNarrowRight } from 'react-icons/tb';
import { Button, Card, Modal, ModalCloseButton, Section, SectionSubtitle, SectionText } from '..';
import * as Styled from './styled';
import type { ApplicationConfirmationModalProps } from './types';

export * from './types';

export const ApplicationConfirmationModal: FC<ApplicationConfirmationModalProps> = (props) => {
  const { translate } = useTranslation();
  const { modal, onConfirm, illustration, daysLeft, loading = false } = props;

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <Section centerChildren>
          <Styled.ModalSectionTitle>
            {translate('mt.buyer.applications.confirmModal.title')}
          </Styled.ModalSectionTitle>

          {illustration}

          <SectionSubtitle>
            {translate('mt.buyer.applications.confirmModal.subtitle')}
          </SectionSubtitle>

          <SectionText
            dangerouslySetInnerHTML={{
              __html: translate('mt.buyer.applications.confirmModal.content').replace(
                '$daysLeft',
                daysLeft ? daysLeft.toString() : '',
              ),
            }}
          />

          <Styled.ButtonContainer>
            <Button
              color="blue"
              onClick={onConfirm}
              iconRight={<TbArrowNarrowRight />}
              loading={loading}
              shrink
            >
              {translate('mt.buyer.applications.confirmModal.button')}
            </Button>
          </Styled.ButtonContainer>
        </Section>
      </Card>
    </Modal>
  );
};
